import { Box, Button, TextField } from '@mui/material';
import React from 'react';

import { Autosuggest, MultiAutosuggest, TrainerAutosuggest } from 'components';
import { CATEGORIES, LEVELS, POSITIONS, BOOLEAN } from 'lib/constants';

const CourseForm = ({ course, handleChange }) => {
	return (
		<Box>
			<TextField
				label="Course Title"
				value={course.title}
				onChange={(e) => handleChange('title', e.target.value)}
				fullWidth
			/>
			<TextField
				label="Description"
				value={course.description}
				onChange={(e) => handleChange('description', e.target.value)}
				fullWidth
			/>
			<Grid container spacing={1}>
				<Grid item md={4} xs={12}>
					<Autosuggest
						options={LEVELS}
						value={course.level || []}
						label="Level"
						name="level"
						placeholder="Select one"
						handleChange={handleChange}
					/>
				</Grid>
				<Grid item md={4} xs={12}>
					<MultiAutosuggest
						options={POSITIONS}
						value={course.positions || []}
						label="Position"
						name="positions"
						placeholder="Select one/many"
						handleChange={handleChange}
					/>
				</Grid>
				<Grid item md={4} xs={12}>
					<TrainerAutosuggest
						value={course.trainer_id}
						label="Trainer"
						name="trainer_id"
						placeholder="Select one"
						handleChange={handleChange}
					/>
				</Grid>
				<Grid item md={4} xs={12}>
					<MultiAutosuggest
						options={CATEGORIES}
						value={course.categories || []}
						label="Skill Category"
						name="categories"
						placeholder="Select one"
						handleChange={handleChange}
					/>
				</Grid>
				<Grid item md={4} xs={12}>
					<Autosuggest
						options={BOOLEAN}
						value={course.featured ? true : false}
						label="Featured Course"
						name="featured"
						placeholder="Select one"
						handleChange={handleChange}
					/>
				</Grid>
				<Grid item md={4} xs={12}>
					<Autosuggest
						options={BOOLEAN}
						value={course.published ? true : false}
						label="Published Course"
						name="published"
						placeholder="Select one"
						handleChange={handleChange}
					/>
				</Grid>
			</Grid>
			<Button
				variant="contained"
				color="primary"
				onClick={() => {
					/* handle save */
				}}
			>
				Save
			</Button>
		</Box>
	);
};

export default CourseForm;
